import React from 'react';

export default (props) => {
    return (
        <table className="table">
            <thead>
                <tr className="d-flex">
                    <th scope="col" className="col">Total</th>
                    <th scope="col" className="col">Daily Average</th>
                    <th scope="col" className="col">Weekly Average</th>
                    <th scope="col" className="col">Monthly Average</th>
                </tr>
            </thead>
            <tbody>
                <tr className="d-flex">
                    <td className="col">{props.total}</td>
                    <td className="col">{props.average}</td>
                    <td className="col">{props.weeklyAverage}</td>
                    <td className="col">{props.monthlyAverage}</td>
                </tr>
            </tbody>
        </table>
    );
}
